module.exports = __webpack_public_path__ + "img/Frame-66.33593f57.svg";